import {
  BtnBold,
  BtnItalic,
  createButton,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnUndo,
  BtnUnderline,
  BtnStrikeThrough,
  BtnStyles,
  HtmlButton,
  Separator,
} from "react-simple-wysiwyg";

/**
 * @function TextEditor
 * @description for TextEditor
 * @returns JSX for TextEditor
 */

export default function TextEditor({ value, onChange }) {
  const BtnAlignCenter = createButton("Align center", "≡", "justifyCenter");
  const styles = { minHeight: "60vh", backgroundColor: "white" };
  return (
    <EditorProvider>
      <Editor value={value} onChange={onChange} style={styles}>
        <Toolbar>
          <BtnRedo />
          <Separator />
          <BtnUndo />
          <Separator />
          <BtnBold />
          <Separator />
          <BtnItalic />
          <Separator />
          <BtnUnderline />
          <Separator />
          <BtnLink />
          <Separator />
          <BtnAlignCenter />
          <Separator />
          <BtnStrikeThrough />
          <Separator />
          <BtnNumberedList />
          <Separator />
          <BtnBulletList />
          <Separator />
          <BtnClearFormatting />
          <Separator />
          <BtnStyles />
          <Separator />
          <HtmlButton />
          <Separator />
        </Toolbar>
      </Editor>
    </EditorProvider>
  );
}
